export default __webpack_public_path__ + "static/media/111_mobile.79fff390.jpg";